
















import { NotificationAction } from '@/components/molecules/notification-section/model/notification-section-model'
import WithActionNotificationSection from '@/components/molecules/notification-section/WithActionNotificationSection.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

/**
 * 移行でいつもの度数がリセットされたユーザーへ、再設定を促すインラインメッセージ。
 *
 * ダイアログにすると本来の目的（商品を見る等）を阻害し、反射的に閉じられて誤注文につながるため、
 * 度数を実際に使う画面にインラインで置く。
 * @see https://github.com/Everforth/growthpalette-front/pull/8515#issuecomment-5121236212
 *
 * 閉じる手段は持たない。消えるのは「いつもの度数を登録したとき」だけで、それはホテラバアプリBFF側の
 * 度数更新がフラグを落とすことで実現している（このコンポーネントからフラグを操作しない）。
 * 閉じるボタンを付けると読まずに消されて再設定されず、リセットされたままになるため。
 * @see https://github.com/Everforth/growthpalette-front/pull/8515#issuecomment-5127668146
 *
 * 表示するかどうか（migrationConflicted が立っているか・保存成功直後に隠すか）は判定せず、
 * 呼び出し側が v-if で制御する。度数の取得・保存はいずれも呼び出し側の画面が握っており、
 * 表示ライフサイクルをこのコンポーネント単体では完結できないため、表示内容だけに関心を持つ。
 *
 * 見た目は既存の通知 UI（`WithActionNotificationSection` / `c-notification`）に揃える。
 * 同じ商品詳細ページには同系統の通知（`ApparelAddToCartArea` のエラー通知等）が出るため、
 * ここで独自のボックスを起こすと見た目の異なる通知が並ぶ。
 *
 * 外側の余白は持たない。設置場所ごとに必要な余白が違うので、呼び出し側で指定する。
 */
@Component({
  components: {
    WithActionNotificationSection,
  },
})
export default class UsualPowerMigrationConflictNotice extends Vue {
  @Prop({ default: true })
  readonly showSettingsAction: boolean

  get settingsAction(): NotificationAction | null {
    if (!this.showSettingsAction) {
      return null
    }

    return {
      label: 'いつもの度数を再登録する',
      onClick: () => {
        window.location.assign(this.settingsPath)
      },
    }
  }

  /**
   * SPA の vue-router は base: '/s'（client/spa/src/router/index.ts）なので、
   * MPA からも辿れる実 URL を使う
   */
  private get settingsPath(): string {
    return '/s/mypage/power-settings'
  }
}
